export const ar = {
  app: {
    stepCreate: 'أنشئ مسابقة مخصصة',
    stepShare: 'ادعُ أصدقاءك',
    stepPlay: 'العب',
    logoS: 'اضغط على S',
  },
  footer: {
    privacy: 'الخصوصية',
    terms: 'الشروط',
    refunds: 'الاسترداد',
    support: 'الدعم',
    pricing: 'الأسعار',
    x: 'X',
    instagram: 'Instagram',
  },
  billing: {
    title: 'الخطط والفوترة',
    subtitle: 'الانضمام إلى مسابقة مجاني دائمًا. اشترك لإنشاء المزيد من المسابقات.',
    planFree: 'Free',
    planBasic: 'Basic',
    planPremium: 'Premium',
    freeIncludes: '{n} مسابقات للتجربة — إلى الأبد',
    quizzesPerMonth: '{n} مسابقة شهريًا',
    perMonth: '/شهر',
    currentPlan: 'خطتك الحالية',
    subscribe: 'اشترك',
    manage: 'إدارة الاشتراك',
    remainingMonthly: 'تبقى لديك {n} من {limit} مسابقة هذا الشهر',
    remainingFree: 'تبقى لديك {n} من {limit} مسابقات مجانية',
    paymentSuccess: 'تم الدفع بنجاح! خطتك مفعّلة الآن.',
    paymentActivating: 'تم استلام الدفع — جارٍ تفعيل خطتك…',
    paymentCancelled: 'تم إلغاء الدفع. لم يتم خصم أي مبلغ.',
    signInFirst: 'سجّل الدخول عبر Google للاشتراك.',
    checkoutError: 'تعذر بدء الدفع. حاول مرة أخرى.',
    backHome: 'العودة إلى الرئيسية',
    quotaExceededTitle: 'استهلكت جميع مسابقاتك',
    quotaExceededBody: 'قم بترقية خطتك لمواصلة إنشاء المسابقات. الانضمام إلى الألعاب يبقى مجانيًا.',
    seePlans: 'عرض الخطط',
    rematchQuotaExceeded: 'تتم إعادة نفس المسابقة — استهلك المضيف حد إنشاء المسابقات الخاص به.',
  },
  auth: {
    signInTitle: 'سجّل الدخول لإنشاء مسابقتك',
    signInHint: 'المضيف فقط يحتاج حسابًا. ينضم الضيوف عبر رابط الدعوة — لا يلزم تسجيل الدخول.',
    signInGoogle: 'المتابعة مع Google',
    signInError: 'فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.',
    signedInAs: 'مسجّل الدخول باسم {email}',
    signOut: 'تسجيل الخروج',
    downloadIosApp: 'تنزيل تطبيق iOS',
    loading: 'جارٍ التحميل…',
  },
  lang: {
    label: 'اللغة',
    en: 'English',
    ru: 'Русский',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ja: '日本語',
    ar: 'العربية',
  },
  setup: {
    title: 'الإعداد مطلوب قبل أن تتمكن من اللعب',
    step1: 'انسخ .env.local.example إلى .env.local',
    step2: 'أدخل عنوان Supabase URL ومفتاح Anon Key',
    step3: 'أضف مفتاح OpenAI API',
    step4: 'شغّل supabase/schema.sql في محرر SQL في Supabase',
    step5: 'أعد تشغيل خادم التطوير',
  },
  create: {
    topic: 'الموضوع',
    topicPlaceholder: 'مثال: رسوم متحركة التسعينيات، علوم، كرة قدم',
    difficulty: 'الصعوبة',
    difficultyEasy: 'سهل',
    difficultyMedium: 'متوسط',
    difficultyHard: 'صعب',
    questions: 'عدد الأسئلة',
    modeTitle: 'وضع اللعب',
    modeRegular: 'تُحسب كل إجابة',
    modeRegularHint: 'أجب فوراً. يمكنك تغيير اختيارك حتى انتهاء الوقت الذي لا يُختصر أبداً — كل من يجيب بشكل صحيح يحصل على نقطة. تنتهي الجولة مبكراً فقط إذا أجاب الجميع.',
    modeHardcore: 'تُحسب الإجابة الأولى فقط',
    modeHardcoreHint: 'النقطة فقط لأول إجابة صحيحة. تُقفل إجابتك لحظة إرسالها — لا تغيير، وللصوت محاولة واحدة. تُرتَّب الإجابات بساعة متزامنة، لذا لا تؤثر سرعة الإنترنت تقريباً.',
    answerTime: 'وقت الإجابة (ثوانٍ)',
    mcTitle: 'اختيار من متعدد',
    mcHint: 'أربع خيارات لكل سؤال — الجميع يختار، وكل إجابة صحيحة تُسجّل نقاطاً',
    cameraTitle: 'كاميرات اللاعبين',
    cameraHint: 'إيقاف = صوت فقط (الميكروفونات تعمل). تشغيل = الجميع يشارك الفيديو.',
    submit: 'إنشاء مسابقة',
    generating: 'جارٍ إنشاء الأسئلة',
    errorEmptyTopic: 'يرجى إدخال موضوع.',
    errorGenerate: 'فشل إنشاء الأسئلة.',
    errorCreate: 'فشل إنشاء اللعبة في قاعدة البيانات.',
    errorGeneric: 'حدث خطأ ما.',
    createdTitle: 'تم إنشاء المسابقة',
    createdHint: 'شارك هذا الرابط مع ما يصل إلى 5 أصدقاء، ثم ادخل المسابقة.',
    shareLink: 'رابط قابل للمشاركة',
    copy: 'نسخ',
    copied: 'تم النسخ',
    enterQuiz: 'الدخول إلى المسابقة',
    adjustShow: 'المزيد',
    adjustHide: 'إخفاء',
    browseOpenGames: 'تصفح الألعاب المفتوحة',
    browseOpenGamesHint: 'انضم إلى مسابقة تنتظر لاعبين',
    inviteOnlyTitle: 'بالرابط فقط',
    inviteOnlyHintOn: 'يمكن لمن لديهم رابطك فقط الانضمام. غير ظاهرة في القائمة العامة.',
    inviteOnlyHintOff: 'تظهر في الألعاب المفتوحة حتى تبدأ المسابقة.',
  },
  rooms: {
    title: 'ألعاب مفتوحة',
    empty: 'لا توجد ألعاب مفتوحة الآن.',
    refresh: 'تحديث',
    join: 'انضمام',
    back: 'رجوع',
    loading: 'جارٍ التحميل…',
    error: 'تعذر تحميل الألعاب المفتوحة.',
    players: '{n}/{max}',
    agoMinutes: 'منذ {n} د',
    agoHours: 'منذ {n} س',
    agoJustNow: 'الآن',
    modeRegular: 'كل إجابة صحيحة تُحسب',
    modeHardcore: 'الأولى فقط تُحسب',
    mc: 'اختيار من متعدد',
    voice: 'صوت',
  },
  join: {
    title: 'الانضمام إلى المسابقة',
    hostTitle: 'أنت المضيف',
    subtitle: 'اختر اسماً ليرى الجميع نتيجتك.',
    namePlaceholder: 'اسمك',
    button: 'انضمام',
    joining: 'جارٍ الانضمام…',
    full: 'هذه اللعبة ممتلئة (حتى 6 لاعبين).',
    errorEmptyName: 'يرجى إدخال اسمك.',
    banned: 'لا يمكنك الانضمام مجدداً إلى هذه اللعبة.',
  },
  lobby: {
    title: 'الردهة',
    players: 'اللاعبون',
    playersCount: '{n} / {max} لاعبين',
    you: 'أنت',
    host: 'المضيف',
    shareInvite: 'شارك هذا الرابط لدعوة لاعبين (حتى 6 إجمالاً)',
    waitingHost: 'في انتظار بدء المضيف…',
    needMore: 'في انتظار لاعب آخر على الأقل…',
    start: 'بدء المسابقة',
    removePlayer: 'إزالة',
    removeConfirm: 'إزالة {name} من هذه اللعبة؟',
    removeConfirmYes: 'إزالة',
    removeConfirmNo: 'إلغاء',
    removeError: 'تعذر إزالة اللاعب.',
    listedPublicly: 'ظاهرة في القائمة حتى تبدأ.',
  },
  game: {
    joining: 'جارٍ الانضمام إلى اللعبة',
    notFound: 'اللعبة غير موجودة',
    notFoundHint: 'تحقق من الرابط وحاول مرة أخرى. إذا كنت المضيف، أنشئ لعبة جديدة.',
    backHome: 'العودة إلى الرئيسية',
    removedTitle: 'تمت إزالتك',
    removedBody: 'قام المضيف بإزالتك من هذه اللعبة.',
    removedHome: 'العودة إلى الرئيسية',
    host: 'المضيف',
    guest: 'ضيف',
    live: 'مباشر',
    offline: 'غير متصل',
    waitingCamera: 'في انتظار الكاميرا',
    cameraErrorPermission: 'الكاميرا/الميكروفون محظوران. اسمح لهذا الموقع ثم المس هنا.',
    cameraErrorInsecure: 'الكاميرا تحتاج رابطًا آمنًا (HTTPS).',
    cameraErrorNotFound: 'لم يُعثر على كاميرا أو ميكروفون. المس لإعادة المحاولة.',
    cameraErrorBusy: 'الكاميرا/الميكروفون مستخدمان في تطبيق آخر. المس لإعادة المحاولة.',
    cameraErrorUnknown: 'تعذّر الوصول إلى الكاميرا/الميكروفون. المس لإعادة المحاولة.',
    cameraErrorTap: 'المس للسماح',
    answering: 'يجيب',
    topic: 'الموضوع',
    question: 'السؤال',
    stealChance: 'فرصة الاستيلاء',
    getReady: 'استعد',
    thinkHint: 'اقرأ السؤال — يُفتح الإجابة للطرفين معاً',
    answerNow: 'أجب الآن',
    tileAnswered: 'أجاب',
    tileThinking: 'يفكر…',
    youAnswering: 'أنت تجيب',
    listeningAnswer: 'الاستماع إلى الإجابة',
    checkingAnswer: 'جارٍ التحقق من الإجابات',
    speakNow: 'تحدث الآن',
    theySpeaking: 'الطرف الآخر يتحدث',
    secondsLeft: 'متبقٍ {n} ث',
    opponentSteal: 'يمكن للخصم الاستيلاء على هذا',
    liveAnswer: 'إجابة مباشرة',
    correctAnswer: 'الإجابة الصحيحة',
    speakAnswerNow: 'قل إجابتك الآن',
    speakHint: 'كلا اللاعبين يجيبان بصوت عالٍ — أول إجابة صحيحة تفوز',
    yourAnswer: 'إجابتك',
    startSpeaking: 'ابدأ بقول إجابتك…',
    holdToAnswer: 'اضغط مع الاستمرار للإجابة',
    recording: 'جارٍ التسجيل… حرّر للإرسال',
    listening: 'الاستماع…',
    holdHint: 'اضغط الزر وقل إجابتك',
    saidNothing: 'لا إجابة',
    done: 'تم',
    doneOptional: 'تأكيد الآن (اختياري)',
    autoSubmitHint: 'تُحفظ إجابتك المنطوقة تلقائياً — لا حاجة للضغط على أي شيء.',
    answerLockedIn: 'تم تأكيد الإجابة',
    waitingOpponent: 'في انتظار اللاعب الآخر…',
    typeYourAnswer: 'اكتب إجابتك أدناه',
    typePlaceholder: 'أو اكتب إجابتك هنا',
    waitShareLink: 'شارك الرابط مع خصمك للبدء',
    waitHostStart: 'في انتظار بدء المضيف',
    bothIn: 'كلا اللاعبين حاضران',
    questionsCount: '{n} أسئلة',
    modeMc: 'اختيار من متعدد',
    modeVoice: 'قل إجابتك',
    startQuiz: 'بدء المسابقة',
    youreIn: 'أنت داخل اللعبة',
    waitHostStartOverlay: 'في انتظار بدء المضيف',
    waitOpponent: 'في انتظار انضمام خصمك',
    connecting: 'جارٍ الاتصال باللعبة',
    pointsMultiplier: '(×{n})',
  },
  buzz: {
    label: 'Buzz',
    tapFirst: 'اضغط للإجابة أولاً',
    youBuzzed: 'ضغطت Buzz، ابدأ بالتحدث',
    otherAnswering: 'اللاعب الآخر يجيب',
    ariaBuzz: 'اضغط Buzz للإجابة',
    ariaDisabled: 'Buzz غير متاح',
  },
  diag: {
    connected: 'متصل',
    connecting: 'جارٍ الاتصال…',
    micOff: 'لم يُكتشف ميكروفون',
    micStalled: 'لا يصل صوت',
    micActive: 'الميكروفون نشط',
    micIdle: 'الميكروفون مكتوم',
    cameraOff: 'لا كاميرا',
  },
  ptt: {
    hold: 'اضغط مع الاستمرار للتحدث',
    talking: 'يتحدث…',
    answerLive: 'الميكروفون مفعّل',
  },
  mc: {
    opponentSteal: 'يمكن للخصم الاستيلاء على هذا',
    answerLocked: 'تم تأكيد الإجابة',
    canChange: 'لا يزال بإمكانك التغيير',
    someoneAnswered: 'أجاب أحدهم — {n} ث للإجابة!',
    you: 'أنت',
  },
  score: {
    vs: 'VS',
    streak: 'سلسلة {n}',
    leaderboard: 'النتائج',
    points: 'نقطة',
  },
  winner: {
    result: 'النتيجة',
    winner: 'الفائز',
    winners: 'الفائزون',
    tie: 'تعادل',
    finalScores: 'النتائج النهائية',
    downloadClips: 'تنزيل مقاطع الإجابات',
    clipLabel: 'س{n} · إجابة {role}',
    download: 'تنزيل',
    rematch: 'إعادة المباراة',
    rematchWaiting: 'في انتظار الآخرين…',
    waitRematch: 'في انتظار بدء المضيف لإعادة المباراة',
    exit: 'خروج',
    discuss: 'ناقشوا النتائج — تنتهي المكالمة خلال {n} ث',
    discussHint: 'تم إيقاف الكاميرا والميكروفون. ابدأ إعادة لمكالمة جديدة.',
  },
} as const;
